<div class="d-flex popup-container">
  <button class="btn btn-link arrow previous" (click)="handlePrevious()">
    <i class="bi bi-chevron-left"></i>
  </button>
  <div class="column left-column d-flex flex-column align-items-center">
    <div class="flex-grow-1 d-flex align-items-center">
      <img
        src="logo-step-b.png"
        alt="Cashback Illustration"
        class="side-logo"
      />
    </div>
    <div class="d-flex flex-row gap-1 align-items-center">
      <small>Powered by</small>
      <img src="quidco.png" alt="Quido" class="powered-by-logo" />
    </div>
  </div>
  <div class="column right-column">
    <div class="mb-5">
      <h4 class="font-weight-bold">How does that work in 4 steps?</h4>
      <ol class="pl-4">
        <li>Create your disposable email in following step</li>
        <li>Create account on retailer page using that email</li>
        <li>Make a purchase using new email address</li>
        <li>
          As disposable emails are forwarded to your private mailbox, you will
          get cashback confirmation immediately
        </li>
      </ol>
    </div>
    <div class="mb-3">
      <button class="btn btn-primary" (click)="stepChange.emit(3)">
        Create disposable email
      </button>
    </div>
    <div>
      <small>
        Need more information on disposable email relay?
        <a href="javascript:">Check our article.</a>
      </small>
    </div>
  </div>
</div>
